import { useTranslations } from '@vocab/react';
import { Stack, Card as BraidCard, Divider } from 'braid-design-system';

import { Card } from 'src/components/Card/Card';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';

import { useGetProfileVisibility2 } from '../../ProfileVisibilityV2/data';
import { ReadApproachability } from '../Approachability/ReadApproachability/ReadApproachability';
import { useApproachability } from '../Approachability/data';
import { ReadAvailability } from '../Availability/ReadAvailability/ReadAvailability';
import { useAvailability } from '../Availability/data';
import { ReadClassification } from '../Classification/ReadClassification/ReadClassification';
import { usePreferredClassification } from '../Classification/data';
import { ReadPreferredLocation } from '../PreferredLocation/ReadPreferredLocation/ReadPreferredLocation';
import { usePreferredLocations } from '../PreferredLocation/data';
import { ReadRightToWork } from '../RightToWork/ReadRightToWork/ReadRightToWork';
import { useRightsToWork } from '../RightToWork/data';
import { ReadSalary } from '../Salary/ReadSalary/ReadSalary';
import { useSalaryPreferences } from '../Salary/data';
import { ReadWorkTypes } from '../WorkTypes/ReadWorkTypes/ReadWorkTypes';
import { useWorkTypes } from '../WorkTypes/data';
import { showApproachability } from '../selectors';
import { emptyRolePreference } from '../utils';

import translations from './.vocab';

export const ReadNextRole = () => {
  const { t } = useTranslations(translations);

  const { profileVisibility2 } = useGetProfileVisibility2();

  const { salaryPreferences, loading: salaryPreferencesLoading } =
    useSalaryPreferences();
  const { rightsToWork, loading: rightsToWorkLoading } = useRightsToWork();

  const { preferredClassification, loading: preferredClassificationLoading } =
    usePreferredClassification();
  const { availability, loading: availabilityLoading } = useAvailability();
  const { workTypes, loading: workTypesLoading } = useWorkTypes();
  const { loading: approachabilityLoading } = useApproachability();
  const { preferredLocations, loading: preferredLocationsLoading } =
    usePreferredLocations();

  const loading =
    salaryPreferencesLoading ||
    rightsToWorkLoading ||
    preferredLocationsLoading ||
    preferredClassificationLoading ||
    availabilityLoading ||
    workTypesLoading ||
    approachabilityLoading;

  const isEmpty = emptyRolePreference({
    workTypes,
    salaryPreferences,
    rightsToWork,
    preferredLocations,
    preferredClassification,
    availability,
  });

  const showApproachabilityField = profileVisibility2
    ? showApproachability(profileVisibility2.__typename)
    : false;

  return (
    <Card
      name="next-role"
      title={t('About your next role')}
      isEmpty={isEmpty}
      loading={loading}
      loader={
        <BraidCard>
          <Stack space="large">
            <Stack space="medium">
              <LoadingItem type="text" size="standard" width="small" />
              <LoadingItem type="text" size="standard" width="small" />
            </Stack>
            <Divider />
            <Stack space="medium">
              <LoadingItem type="text" size="standard" width="small" />
              <LoadingItem type="text" size="standard" width="small" />
            </Stack>
            <Divider />
            <Stack space="medium">
              <LoadingItem type="text" size="standard" width="small" />
              <LoadingItem type="text" size="standard" width="small" />
              <LoadingItem type="text" size="standard" width="small" />
            </Stack>
          </Stack>
        </BraidCard>
      }
    >
      <BraidCard>
        <Stack space="large">
          <ReadAvailability />
          <Divider />
          <ReadWorkTypes />
          <Divider />
          <ReadPreferredLocation />
          <Divider />
          <ReadRightToWork />
          <Divider />
          <ReadSalary />
          <Divider />
          <ReadClassification />
          {showApproachabilityField && (
            <>
              <Divider />
              <ReadApproachability />
            </>
          )}
        </Stack>
      </BraidCard>
    </Card>
  );
};
